import { type ReactElement } from 'react'
import { isEmpty, type NotificationView } from '@terros/common'
import { Link } from '@tanstack/react-router'
import { Alert, Button, Anchor, Group, ScrollArea, Stack, Title } from '@mantine/core'
import { useNotificationUnreadCount, useNotificationList } from '@front/model'
import { NotificationViews } from './NotificationViews'
import { NotificationList } from './NotificationList'
import { MarkAllRead } from './MarkAllRead'

export function NotificationPanel({
  onOpen,
  view,
  onViewChange,
}: {
  onOpen: VoidFunction
  view: NotificationView
  onViewChange: (view: NotificationView) => void
}): ReactElement {
  const count = useNotificationUnreadCount()
  const query = useNotificationList({ view })
  return (
    <Stack gap='sm'>
      <Group justify='space-between' wrap='nowrap'>
        <Title order={2} size={16}>
          Notifications
        </Title>
        {view !== 'archived' && <MarkAllRead disabled={query.isLoading || !query.isSuccess || isEmpty(query.data)} />}
      </Group>
      <NotificationViews view={view} onChange={onViewChange} />
      {count.error && (
        <Alert role='alert' color='red' title='Could not refresh unread count'>
          {count.error}
          <Button onClick={count.refetch}>Retry</Button>
        </Alert>
      )}
      <ScrollArea.Autosize mah='60vh' scrollbars='y' styles={{ content: { display: 'block', minWidth: 0 } }}>
        <NotificationList query={query} onOpen={onOpen} />
      </ScrollArea.Autosize>
      <Anchor component={Link} to='/notifications' onClick={onOpen}>
        View all notifications
      </Anchor>
    </Stack>
  )
}
